/**
 * @module events/types/blur
 */

/**
 * @type {string}
 */
export default 'blur'
